<template>
  <div class="container" v-if="codeDialogFlag">
    <div class="dialog-box">
      <div class="contact-us-dialog-title">联系我们</div>
      <i class="el-icon-circle-close" @click="closeDialog"></i>
      <div class="dialog-content">
        <div class="dialog-content-left">
          <img src="../../../assets/images/customer.png" style="width:138px;" alt="" />
          <div class="text">使用微信扫一扫</div>
        </div>
        <div class="dialog-content-right">
          <div class="service-title">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/telephone_icon.png"
              alt="">
            服务热线
          </div>
          <div class="desc-text">（周一至周五9:00~18:00）</div>
          <div class="phone">0512-67367378</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    codeDialogFlag: Boolean
  },
  data() {
    return {
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog")
    },
  }
}
</script>

<style lang="stylus" scoped>
  .container {
      width:100%;
      display:flex;
      justify-content:center;
      align-items:center;
      .dialog-box {
        background-color:#fff;
        width:27rem;
        position:relative;
        max-width:500px;
        min-width:350px;
        /deep/.el-icon-circle-close {
          position:absolute;
          right:1rem;
          top:20px;
          font-size:25px;
          color:#fff;
          cursor:pointer;
        }
        .contact-us-dialog-title {
          height: 3.75rem; //px;
          line-height:3.75rem;
          text-align:center;
          color:#fff;
          font-size:1.25rem;
          letter-spacing:1px;
          background: #2372E9;
        }
        .dialog-content {
          padding:2.56rem 2.87rem 2.56rem;
          border-bottom:1px solid #E8E8E8;
          display:flex;
          justify-content:space-around;
          align-items:center;
          img {
            margin-bottom:10px;
           }
          .text {
            text-align:center;
          }
          .dialog-content-right {
            text-align:center;
            .service-title {
              display:flex;
              justify-content:center;
              font-weight:bold;
              margin-bottom:9px;
              font-size:18px;
              color:#333; 
              img {
                width:24px;
                margin-right:8px;
              }
            }
            .desc-text {
              color:#999999;
              font-size:14px;
              margin-bottom:15px;
            }
            .phone {
              font-size:24px;
              color:#2372E9;
              font-weight:bold;
            }
          }
        }
        .dialog-footer {
          padding:1.75rem 2.68rem;
          >div {
            display:flex;
          align-items:center;
          }
          .phone {
            color:#2372E9;
            font-size:2rem;
          }
        }
      }
    }
  </style>